<template>
    <page>
        <module enable-flex>
            <c-tab-list :tabs="tabList" type="border-tab" @change="changeTab">
            </c-tab-list>
            <div class="m-account-content flex-grow">
                <section v-if="activeTab === 'merchant'" class="m-merchant-panel">
                    <div class="m-merchant-head flex-center-cross">
                        <div class="m-logo" @click="uploadLogo">
                            <img :src="merchant.saas_logo || defaultLogo">
                            <div class="m-logo-upload">
                                <i class="tf tf-plus"></i>
                                <span>{{merchant.saas_logo ? '更换LOGO' : '上传LOGO'}}</span>
                            </div>
                        </div>
                        <div>
                            <div class="m-name">
                                <template v-if="editingName">
                                    <c-input v-model="editingNameValue" class="m-name-input" size="small"
                                             @keyup.enter.native="saveName"></c-input>
                                    <i class="tf tf-check m-name-action" title="保存" @click="saveName"></i>
                                    <i class="tf tf-close m-name-action" title="取消" @click="cancelEditName"></i>
                                </template>
                                <template v-else>
                                    {{ merchant.saas_name || '-' }}
                                    <i class="tf tf-edit m-name-edit" title="修改名称" @click="startEditName"></i>
                                </template>
                            </div>
                            <div class="m-code">
                                商户代码：{{ merchant.saas_id || '-' }}
                            </div>
                        </div>
                    </div>
                    <div class="m-info-grid">
                        <div>
                            <label>
                                系统版本：
                            </label>
                            <img v-if="merchant.icon_img_url" class="m-version-icon" :src="merchant.icon_img_url">
                            <span class="m-version">
                                {{ merchant.version_name || '-' }}
                            </span>
                        </div>
                        <div>
                            <label>
                                到期时间：
                            </label>
                            {{ merchant.auth_exp_date || '-' }}
                            <span v-if="merchant.remaining_effective_days !== undefined" class="m-expire">
                                剩余{{ merchant.remaining_effective_days }}天
                            </span>
<!--                            <c-button color="main" size="mini" class="m-renew-btn" @click="renewLicense">-->
<!--                                我要续期-->
<!--                            </c-button>-->
                        </div>
                        <div>
                            <label>
                                云环境：
                            </label>
                            {{ merchant.cloud_environment || '-' }}
                        </div>
                        <div>
                            <label>
                                产品：
                            </label>
                            {{ merchant.system_name || '-' }}
                        </div>
                    </div>
                    <div class="m-product-records">
                        <c-title>
                            产品开通记录
                        </c-title>
                        <c-table :data="productRecords" border :paging="false">
                            <c-table-column label="交易订单号" name="order_no" width="180">
                            </c-table-column>
                            <c-table-column label="开通产品" name="product_name" width="260">
                            </c-table-column>
                            <c-table-column label="开通期限" name="opening_term" width="120">
                            </c-table-column>
                            <c-table-column label="产品开通时间" name="start_date" width="150">
                            </c-table-column>
                            <c-table-column label="产品到期时间" name="exp_date" width="150">
                            </c-table-column>
                            <c-table-column label="备注说明" name="remark" width="200">
                            </c-table-column>
                        </c-table>
                    </div>
                </section>
                <section v-else-if="activeTab === 'payment'" class="m-payment-panel">
                    <c-title>收款码</c-title>
                    <c-form ref="paymentForm" class="m-payment-form" unit-width="420px">
                        <c-form-item label="上传收款码">
                            <div class="m-pay-codes flex-start-end">
                                <img v-if="payment.qr_code_url" :src="payment.qr_code_url" @click="previewCode">
                                <button v-else @click="uploadCode">
                                    上传收款码
                                </button>
                                <template v-if="payment.qr_code_url">
                                    <span class="m-pay-code-link" @click="uploadCode">更换</span>
                                    <span class="m-pay-code-link m-pay-code-link--danger" @click="clearCode">删除</span>
                                </template>
                            </div>
                        </c-form-item>
                    </c-form>
                    <c-title>银行转账信息</c-title>
                    <c-form ref="paymentForm" class="m-payment-form" unit-width="420px">
                        <c-form-item label="收款银行">
                            <c-input v-model="payment.bank_name" name="bank_name" placeholder="例：工商银行 XX支行">
                            </c-input>
                        </c-form-item>
                        <c-form-item label="收款户名">
                            <c-input v-model="payment.bank_account_name" name="bank_account_name"
                                     placeholder="请输入收款户名">
                            </c-input>
                        </c-form-item>
                        <c-form-item label="收款账号">
                            <c-input v-model="payment.bank_account_no" name="bank_account_no" placeholder="请输入收款账号">
                            </c-input>
                        </c-form-item>
                        <c-form-item>
                            <c-button size="form" color="main" @click="savePayment">提交并保存</c-button>
                        </c-form-item>
                    </c-form>
                </section>
                <address-list v-else address-types="1,2">
                </address-list>
            </div>
        </module>
    </page>
</template>
<script>
import addressList from './address_list.vue'
export default {
    name:
        'accountAuth',
    components: {
        addressList
    },
    data() {
        return {
            activeTab: 'merchant',
            merchant: {},
            productRecords: [],
            payment: {},
            editingName: false,
            editingNameValue: '',
            defaultLogo: require('@/assets/image/icon.png'),
            tabList: [{
                name: '商户信息',
                value: 'merchant'
            },
                {
                    name: '线下支付渠道维护',
                    value: 'payment'
                },
                {
                    name: '地址管理',
                    value: 'address'
                }]
        };
    },
    mounted() {
        this.loadMerchant();
        this.loadProductRecords();
    },
    methods: {
        changeTab(tab) {
            this.activeTab = tab.value;
            if (tab.value === 'payment') this.loadPayment();
        },
        loadMerchant() {
            this.request({
                url: '/sys_saas/detail',
                success: data => {
                    this.merchant = data || {}
                }
            });
        },
        loadProductRecords() {
            this.request({
                url: '/sys_saas/product/record/list',
                success: data => {
                    this.productRecords = Array.isArray(data) ? data : [];
                }
            });
        },
        loadPayment() {
            this.request({
                url: '/sys_saas/payment/detail',
                success: data =>{
                    this.payment = data || {};
                }
            });
        },
        renewLicense() {
            // TODO: 对接续期跳转或弹窗逻辑
            this.$message({message: '续期功能待对接', type: 'warning'});
        },
        uploadLogo() {
            this.$upload({
                type: 'image',
                loading: true,
                success: data => {
                    const file = data && data[0];
                    if (!file || !file.path) return;
                    this.saveLogo(file.path);
                }
            });
        },
        saveLogo(saasLogo) {
            this.request({
                url: '/sys_saas/edit/logo',
                data: {saas_logo: saasLogo},
                loading: true,
                success: (data, msg) => {
                    this.$set(this.merchant, 'saas_logo', saasLogo);
                    this.$message({message: msg || 'LOGO修改成功', type: 'success'});
                }
            });
        },
        startEditName() {
            this.editingNameValue = this.merchant.saas_name || '';
            this.editingName = true;
        },
        cancelEditName() {
            this.editingName = false;
            this.editingNameValue = '';
        },
        saveName() {
            const saasName = (this.editingNameValue || '').trim();
            if (!saasName) {
                this.$message({message: '请输入商户名称', type: 'warning'});
                return;
            }
            this.request({
                url: '/sys_saas/edit/name',
                data: {saas_name: saasName},
                loading: true,
                success: (data, msg) => {
                    this.$set(this.merchant, 'saas_name', saasName);
                    this.editingName = false;
                    this.editingNameValue = '';
                    this.$message({message: msg || '商户名称修改成功', type: 'success'});
                }
            });
        },
        previewCode() {
            this.$preview({
                src: this.payment.qr_code_url
            });
        },
        clearCode() {
            this.$confirm({
                message: '确认清除收款码？',
                cancelButton: true,
                resolve: () => {
                    this.$set(this.payment, 'qr_code_url', '');
                    this.savePayment('收款码已清除');
                }
            });
        },
        uploadCode() {
            this.$upload({
                type: 'image',
                loading: true,
                success: data =>{
                    const file = data && data[0];
                    if (!file || !file.path) return;

                    this.$set(this.payment, 'qr_code_url', file.path);
                    // 收款码仅维护一个，上传完成后立即持久化。
                    this.savePayment('收款码上传并保存成功');
                }
            });
        },
        getPaymentPayload() {
            const {saas_id, qr_code_url, bank_name, bank_account_name, bank_account_no, update_date} = this.payment;
            return {
                saas_id,
                qr_code_url,
                bank_name,
                bank_account_name,
                bank_account_no,
                update_date
            };
        },
        savePayment(successMessage = '保存成功') {
            this.request({
                url: '/sys_saas/payment/save',
                data: this.getPaymentPayload(),
                loading: true,
                success: (data, msg) =>{
                    if (data && typeof data === 'object' && !Array.isArray(data)) {
                        this.payment = data;
                    }
                    this.$message({
                        message: msg || successMessage,
                        type: 'success'
                    });
                }
            });
        }
    }
}
</script>
<style lang="stylus" scoped>
    .m-account-content {
        padding: 16px;
        background: #fff;
        overflow: auto;
    }
    .m-merchant-head {
        margin: 16px 0 28px;
    }
    .m-logo {
        position: relative;
        width: 96px;
        height: 96px;
        margin-right: 20px;
        border: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden;
        background: #112c5c;
    }
    .m-logo img {
        max-width: 100%;
        max-height: 100%;
    }
    .m-logo-upload {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        font-size: 12px;
        opacity: 0;
        transition: opacity 0.2s;
    }
    .m-logo:hover .m-logo-upload {
        opacity: 1;
    }
    .m-logo-upload .tf {
        font-size: 20px;
    }
    .m-name {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 20px;
        font-weight: 600;
        color: #222;
    }
    .m-name-input {
        width: 240px;
    }
    .m-name-edit,
    .m-name-action {
        font-size: 16px;
        color: #0D6EFE;
        cursor: pointer;
    }
    .m-name-edit:hover,
    .m-name-action:hover {
        opacity: 0.8;
    }
    .m-code
    {
        margin-top: 12px;
        color: #666;
    }
    .m-info-grid {
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-width: 900px;
        line-height: 24px;
    }
    .m-info-grid > div {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .m-info-grid label {
        flex-shrink: 0;
        width: 80px;
        color: #888;
        text-align: right;
    }
    .m-product-records {
        margin-top: 36px;
    }
    .m-version {
        color: #b66b00;
        font-weight: 600;
    }
    .m-version-icon {
        width: 20px;
        height: 20px;
        object-fit: contain;
        vertical-align: middle;
    }
    .m-expire {
        margin-left: 12px;
        color: #f04444;
        font-weight: 600;
    }
    .m-renew-btn {
        margin-left: 12px;
    }
    .m-pay-codes {
        display: flex;
        gap: 12px;
        margin: 0 0 32px 10px;
    }
    .m-pay-codes > div {
        display: flex;
        flex-direction: column;
        gap: 10px;
        color: #666;
    }
    .m-pay-codes img {
        width: 120px;
        height: 120px;
        object-fit: contain;
        border: 1px dashed #ddd;
        cursor: pointer;
    }
    .m-pay-code-link {
        color: #0D6EFE;
        cursor: pointer;
        font-size: 13px;
    }
    .m-pay-code-link:hover {
        text-decoration: underline;
    }
    .m-pay-code-link--danger {
        color: #f04444;
    }
    .m-pay-codes button {
        width: 120px;
        height: 120px;
        border: 1px dashed #ddd;
        color: #888;
        background: #fff;
        cursor: pointer;
    }
    .m-payment-form {
        max-width: 620px;
    }
</style>
